export type ModuleName = "assignments"
export const MODULE_NAME: ModuleName = "assignments"
